import { TranscriptEntry, TranscriptParticipant } from '../../../platform-call';

export function filterQuotesByParticipants(
    participants: TranscriptParticipant[] | null,
    quotes: TranscriptEntry[],
): TranscriptEntry[] {
    if (participants == null || participants.length === 0) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        return participants.some((e) => {
            return e.speaker?.toLowerCase() === q.speaker?.toLowerCase();
        });
    });
}
